<template>
    <div style="text-align: center;">

        <el-tabs type="border-card" v-model="activeName" @tab-click="handleClick">
            <el-tab-pane v-for="item in tableList" :key="item.id" :name="item.idName" :label=item.queueName>
                <!--  表格 -->
                <div class="table">
                    <div class="left_table">
                        <div id="table">
                            <div class="tables">
                                <span class="span_one">序号</span>
                                <span class="span_one">车牌号</span>
                                <span class="span_one">状态</span>
                                <span class="span_one">提示</span>
                            </div>
                            <vue-seamless-scroll :class-option="seamlessScrollOption" :data="typeList"
                                class="seamless-warp">
                                <ul class="item">
                                    <li v-for="(item1, index) in typeList" :key="index">
                                        <span v-text="item1.lineUpNo" :class="[item1.jobStatusName === '已叫号' ? 'typeColor01' : 'typeColor02']"></span>
                                        <span v-text="item1.vehicleNo" :class="[item1.jobStatusName === '已叫号' ? 'typeColor01' : 'typeColor02']"></span>
                                        <span v-text="item1.jobStatusName"
                                            :class="[item1.jobStatusName === '已叫号' ? 'typeColor01' : 'typeColor02']"></span>
                                        <span v-text="item1.status" :class="[item1.jobStatusName === '已叫号' ? 'typeColor01' : 'typeColor02']"></span>
                                        <!-- <span>{{ item.operationTime | formatDate }}</span> -->
                                    </li>
                                </ul>
                            </vue-seamless-scroll>
                        </div>
                    </div>
                </div>
            </el-tab-pane>
        </el-tabs>


    </div>
</template>
   
<script>
import { getBtn } from '@/utils/getButton'
import vueSeamlessScroll from 'vue-seamless-scroll'
import { emptyFn, dateTimeFormat, dateFormat } from '@/utils/util'
import DonMessage from '@/utils/message'
import { getSchedulingAssignmentList, getCallScreenList, queueSettingsList } from '@/api/lj'
export default {
    components: {
        vueSeamlessScroll
    },
    data() {
        return {
            h: 500,
            activeName: '',
            codeTimer: null,//定时器
            dateTimeFormat: dateTimeFormat,
            dateFormat: dateFormat,
            emptyFn: emptyFn,
            list1: [],
            tableList: [],
            typeList: [],


        }
    },
    created() {
        this.getList()
    },

    methods: {

        handleClick(tab, event) {
            this.typeList = []
            const janeObj = this.tableList.find(obj => obj.queueName == tab.label)
            getCallScreenList({ queueId: janeObj.id }).then(res1 => {
                if (res1.length !== 0) {
                    this.typeList = res1
                    console.log(this.typeList, 'this.typeList')
                    while (this.typeList.length > 20) {
                        this.typeList.push(...this.typeList)
                    }

                    // overNumber 
                    // 作业状态名称：1：排队中 2：已叫号 3：已过号 4：已失效 5：已进场 6：进仓过磅完成 7：出仓过主磅完成 8：出仓过副磅完成 9：已出仓
                    this.typeList.forEach((item, index) => {
                        item.status = ''
                        if (item.jobStatusName == '排队中') {
                            item.status = '请等待叫号进仓!'
                        }
                        if (item.jobStatusName == '已过号' && item.overNumber == 0) {
                            item.status = '已过号，请在手机上重新报到!'
                        }
                        if (item.jobStatusName == '已过号' && item.overNumber > 0) {
                            item.status = '已过号' + item.overNumber + '次，请在手机上重新报到!'
                        }
                        if (item.jobStatusName == '已叫号' && item.overNumber == 0) {
                            item.status = '请尽快进仓!'
                        }
                        if (item.jobStatusName == '已叫号' && item.overNumber > 0) {
                            item.status = '已过号' + item.overNumber + '次，请尽快进仓!'
                        }

                    })
                }

            }).catch(err => {
                DonMessage.error(err.message)
            })
        },
        // 获取列表
        getList() {
            const loading = this.$loading({
                lock: true,
                text: '正在处理...'
            })
            let that = this
            queueSettingsList({
                pageNo: 1,
                pageSize: 9999,
            }).then(res => {
                loading.close()

                if (res.list.length !== 0) {
                    res.list.forEach((item, index) => {
                        item.idName = "'" + item.id + "'"
                    })
                    that.activeName = res.list[0].idName
                    that.tableList = res.list
                    that.$nextTick(() => {
                        that.codeTimer = setInterval(() => {
                            // 获取当前tab的index          \
                            setTimeout(() => {

                                let index = that.tableList.findIndex(o => o.idName == that.activeName)
                                let id = ''
                                if (index >= that.tableList.length - 1) {
                                    that.activeName = that.tableList[0].idName
                                    id = that.tableList[0].id
                                } else {
                                    that.activeName = that.tableList[index + 1].idName
                                    id = that.tableList[index + 1].id

                                }
                                getCallScreenList({ queueId: id }).then(res1 => {
                                    that.typeList = res1
                                    while (this.typeList.length > 20) {
                                        this.typeList.push(...this.typeList)
                                    }

                                }).catch(err => {
                                    DonMessage.error(err.message)
                                })
                            }, 0)
                        }, 10000)
                    })

                }

            }).catch(err => {
                DonMessage.error(err.message)
                loading.close()

            })

        },
    },
    computed: {
        seamlessScrollOption() {
            return {
                step: 0.15, // 数值越大速度滚动越快
                limitMoveNum: 10, // 开始无缝滚动的数据量 this.dataList.length
                hoverStop: true, // 是否开启鼠标悬停stop
                direction: 1, // 0向下 1向上 2向左 3向右
                openWatch: true, // 开启数据实时监控刷新dom
                singleHeight: 0, // 单步运动停止的高度(默认值0是无缝不停止的滚动) direction => 0/1
                singleWidth: 0, // 单步运动停止的宽度(默认值0是无缝不停止的滚动) direction => 2/3
                waitTime: 1000, // 单步运动停止的时间(默认值1000ms)
            };
        },
    },
}
</script>
   
<style scoped lang='less'>
.seamless-warp {
    font-size: 25px;
    height: 89.5vh;
    overflow: hidden;


    ul {
        margin: 0;
        padding: 0;
    }

    li {
        display: flex;
        width: 100%;
        // height: 5vh;
        // line-height: 5vh;
        color: #fff;
        background-color: #000;
        border-bottom: 1px solid #fff;
        height:auto!important; 
        span {
            flex: 1;
            width: 100%;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            padding: 0 8px;
            text-align: center;
        }

        .typeColor01 {
            color: #f70505;
        }
        .typeColor02 {
            color: #fff;
        }

        .span {
            flex: 1;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
        }
    }
}

.el-tabs[data-v-f0e26516] {
    position: absolute;
    background-color: #000;
    // left: 1%;
    // top: 2%;
    width: 99.8%;
    height: 99.8%;
    text-align: center;
    overflow: auto;

}

::v-deep [data-v-f0e26516] .el-tabs--border-card>.el-tabs__header .el-tabs__item {
    flex: 1;
    font-size: 25px;
    border: 1px solid #000;
}

::v-deep .el-tabs--border-card>.el-tabs__header {
    background-color: #000;
    height:auto!important; 
    overflow:hidden;
}
// .el-tabs--border-card>.el-tabs__header{
//     background-color: #F5F7FA;
//     /* border-bottom: 1px solid #E4E7ED; */
//     margin: 0;
//     height: 5vh;
//     line-height: 5vh;
//     overflow:hidden;
// }
::v-deep .el-tabs__nav {
    display: flex;
    // width: 1000px;
}

::v-deep .el-tabs--border-card>.el-tabs__content {
    padding: 0px;
    background: #000; 
}
::v-deep .el-tabs--border-card {
    background: #000; 
    height: 99.8%;
}

::v-deep .el-tabs--border-card>.el-tabs__header .is-active {
    flex: 1;
    font-size: 30px;
    border: 1px solid #000;
    color: #f70505;
    background-color: #000;
    position: relative;
}

.el-main {
    position: relative;

}

.left_table {
    .tables {

        background-color: #000;
        width: 100%;
        color: #fff;
        // height: 5vh;
        // line-height: 5vh;
        display: flex;
        text-align: center;
        border-bottom: 1px solid #fff;
        height:auto!important; 
        .span_one {
            font-size: 25px;
        }

        span {
            flex: 1;
        }
    }
}
</style>
   